module.exports = __webpack_public_path__ + "static/media/39 3 57.c99cc499.png";